import { Role, SystemRole } from '../models/role.model';

export const MOCK_ROLES: Role[] = [
  {
    id: 1,
    name: 'super_admin',
    displayName: 'Super Administrator',
    displayNameKey: 'roles.super-administrator',
    description: 'Full system access with all permissions',
    descriptionKey: 'roles.super-administrator-description',
    isSystemRole: true,
    isActive: true,
    createdDate: new Date('2020-01-15T00:00:00Z'),
    updatedDate: new Date('2024-01-10T14:30:00Z'),
    level: 100,
    userCount: 1,
  },
  {
    id: 2,
    name: 'admin',
    displayName: 'Administrator',
    displayNameKey: 'roles.administrator',
    description: 'Administrative access to most system features',
    descriptionKey: 'roles.administrator-description',
    isSystemRole: true,
    isActive: true,
    createdDate: new Date('2020-01-15T00:00:00Z'),
    updatedDate: new Date('2024-01-10T14:30:00Z'),
    level: 90,
    userCount: 2,
  },
  {
    id: 3,
    name: 'manager',
    displayName: 'Property Manager',
    displayNameKey: 'roles.property-manager',
    description: 'Property management access with resident and vendor management',
    descriptionKey: 'roles.property-manager-description',
    isSystemRole: true,
    isActive: true,
    createdDate: new Date('2020-01-15T00:00:00Z'),
    updatedDate: new Date('2024-01-10T14:30:00Z'),
    level: 80,
    userCount: 3,
  },
  {
    id: 4,
    name: 'resident',
    displayName: 'Resident',
    displayNameKey: 'roles.resident',
    description: 'Resident access to personal features and requests',
    descriptionKey: 'roles.resident-description',
    isSystemRole: true,
    isActive: true,
    createdDate: new Date('2020-01-15T00:00:00Z'),
    updatedDate: new Date('2024-01-10T14:30:00Z'),
    level: 30,
    userCount: 45,
  },
  {
    id: 5,
    name: 'vendor',
    displayName: 'Vendor',
    displayNameKey: 'roles.vendor',
    description: 'Vendor access to assigned requests and jobs',
    descriptionKey: 'roles.vendor-description',
    isSystemRole: true,
    isActive: true,
    createdDate: new Date('2020-01-15T00:00:00Z'),
    updatedDate: new Date('2024-01-10T14:30:00Z'),
    level: 20,
    userCount: 12,
  },
  {
    id: 6,
    name: 'guest',
    displayName: 'Guest',
    displayNameKey: 'roles.guest',
    description: 'Limited guest access to public features',
    descriptionKey: 'roles.guest-description',
    isSystemRole: true,
    isActive: true,
    createdDate: new Date('2020-01-15T00:00:00Z'),
    updatedDate: new Date('2024-01-10T14:30:00Z'),
    level: 10,
    userCount: 0,
  },
  {
    id: 7,
    name: 'maintenance_tech',
    displayName: 'Maintenance Technician',
    displayNameKey: 'roles.maintenance-technician',
    description: 'Maintenance staff with access to work orders and equipment',
    descriptionKey: 'roles.maintenance-technician-description',
    isSystemRole: false,
    isActive: true,
    createdDate: new Date('2023-06-01T00:00:00Z'),
    updatedDate: new Date('2024-01-10T14:30:00Z'),
    level: 40,
    userCount: 5,
  },
  {
    id: 8,
    name: 'concierge',
    displayName: 'Concierge',
    displayNameKey: 'roles.concierge',
    description: 'Front desk staff with resident assistance capabilities',
    descriptionKey: 'roles.concierge-description',
    isSystemRole: false,
    isActive: true,
    createdDate: new Date('2023-06-01T00:00:00Z'),
    updatedDate: new Date('2024-01-10T14:30:00Z'),
    level: 35,
    userCount: 3,
  },
];
